module.exports = __webpack_public_path__ + "static/trips-detail-07c709d6c1e954e5c42ab4378da2480c.png";